<template>
  <div class="show-area" :style="{ width: `${width}px`, height: `${height}px` }">
    <div class="scroll-area" >
      <!-- ����margin��ʹ���� �д��޵��еĳ���Ч�� -->
      <div class="slot-container" :style="{ margin: `0 ${width}px` }">
        <div v-for="(item, index) in newsItems" :key="index" class="news-item">
          <a  style="color: #333; text-decoration: none;cursor: pointer;" @click="moreNotice(item.id)"> {{ item.articleTitle }} </a>
      </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'

export default Vue.extend({
  props: {
    // �Զ��������ƿ���
    width: {
      type: Number,
      default() {
        return 1500
      }
    },
    // �Զ��������Ƹ߶�
    height: {
      type: Number,
      default: 20
    },
    newsItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentIndex: 0,
      itemWidth: 0,
      totalWidth: 0,
      animationFrameId: 0
    }
  },
  mounted() {
      this.initMarquee()
  },

  beforeDestroy() {
    // ���������ǰ��ȡ������
    cancelAnimationFrame(this.animationFrameId)
    const showArea = document.querySelector('.show-area')
    if (showArea) {
      showArea.scrollLeft = 0
    }
  },

  methods: {
    moreNotice(id) {
      this.$router.push({ name: "Proclamation" });
    },
    initMarquee() {
      setTimeout(() => {
        const showArea = document.querySelector('.show-area')
        const scrollArea = document.querySelector('.scroll-area')

        if (showArea && scrollArea) {
          this.itemWidth = scrollArea.scrollWidth / this.newsItems.length
          this.totalWidth = scrollArea.scrollWidth

          // �����ұ߿�ʼ����
          showArea.scrollLeft = this.totalWidth

          this.startMarquee()
        }
      }, 100)
    },
    startMarquee() {
      const showArea = document.querySelector('.show-area')
      if (!showArea) return

      const f = () => {
        const currentScrollLeft = showArea.scrollLeft

        // �����������һ��������Ŀ
        if (currentScrollLeft < (this.currentIndex + 1) * this.itemWidth) {
          this.currentIndex++
          if (this.currentIndex >= this.newsItems.length) {
            this.currentIndex = 0
            showArea.scrollLeft = this.totalWidth
          }
        }

        // �����ٶ�
        const speed = 1
        showArea.scrollLeft -= speed

        // ʹ��requestAnimationFrame�Ż�����Ч��
        this.animationFrameId = requestAnimationFrame(f)
      }

      f()
    }
  }
})
</script>

<style lang="scss" scoped>
.show-area {
  display: inline-block;
  white-space: nowrap;
   overflow: hidden;
  .scroll-area {
    display: inline-block;
    white-space: nowrap; // ȷ�����ݲ�����
    .slot-container {
      display: inline-block;
      white-space: nowrap; // ȷ�����ݲ�����
      .news-item {
        display: inline-block;
        white-space: nowrap; // ȷ�����ݲ�����
        margin-right: 20px; // ÿ����Ŀ֮��ļ��
      }
    }
  }
}
</style>
